import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getGenerateEmailOtpBody = (emailId: string) => {
  return {
    user: { mobile: { mobileNumber: '1234567890', countryCode: '91' }, emailAddress: emailId },
    scope: 'REQUEST',
    authenticateList: [{ mode: '43', action: 'generate' }],
    purpose: 2,
  }
}

const generateEmailOtp = (emailId: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: getGenerateEmailOtpBody(emailId),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { generateEmailOtp }
